import styled from "styled-components";

export const GalleryWrap = styled.div`
	position: relative;
	width: 100%;
	height: auto;
    img{
        border-radius: 5px;
    }
`;